// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__QTej+","rightHeaderSpan":"Header_rightHeaderSpan__qWbfB","toolbarSpan":"Header_toolbarSpan__3rU41"};